import { FormattedIdentityProviderConfiguration } from "@idw-types/data/identity-providers";
import { IdentityProvidersReferenceData } from "@idw-types/state/identity-providers-state";

export enum IdentityProvidersActionTypes {
    SET_IDENTITY_PROVIDER_CONFIGURATIONS_LOADING = "SET_IDENTITY_PROVIDER_CONFIGURATIONS_LOADING",
    SET_IDENTITY_PROVIDER_CONFIGURATIONS = "SET_IDENTITY_PROVIDER_CONFIGURATIONS",
    SET_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING = "SET_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING",
    SET_IDENTITY_PROVIDERS_REFERENCE_DATA = "SET_IDENTITY_PROVIDERS_REFERENCE_DATA"
}

type SetIdentityProviderConfigurationsLoadingAction = {
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setIdentityProviderConfigurationsLoading = (isLoading: boolean): SetIdentityProviderConfigurationsLoadingAction => ({
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS_LOADING,
    payload: { isLoading }
});

type SetIdentityProviderConfigurationsAction = {
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS,
    payload: { identityProviderConfigurations: Array<FormattedIdentityProviderConfiguration>; }
}

export const setIdentityProviderConfigurations = (identityProviderConfigurations: Array<FormattedIdentityProviderConfiguration>): SetIdentityProviderConfigurationsAction => ({
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDER_CONFIGURATIONS,
    payload: { identityProviderConfigurations }
});

type SetIdentityProvidersReferenceDataLoading = {
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean; }
};

export const setIdentityProvidersReferenceDataLoading = (isLoading: boolean): SetIdentityProvidersReferenceDataLoading => ({
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetIdentityProvidersReferenceData = {
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA,
    payload: { referenceData: IdentityProvidersReferenceData; }
};

export const setIdentityProvidersReferenceData = (referenceData: IdentityProvidersReferenceData): SetIdentityProvidersReferenceData => ({
    type: IdentityProvidersActionTypes.SET_IDENTITY_PROVIDERS_REFERENCE_DATA,
    payload: { referenceData }
});

export type IdentityProvidersActions =
    SetIdentityProviderConfigurationsLoadingAction |
    SetIdentityProviderConfigurationsAction |
    SetIdentityProvidersReferenceDataLoading |
    SetIdentityProvidersReferenceData